/**
 * 模版市场模态框容器
 * @author chenqunfeng
 * @since 17/10/31
 */

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import StoreTplModal from 'components/store-tpl-modal';
import { showModal } from 'actions//modal';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      showModal,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreTplModal);
